import _ from 'lodash';

// For development use the local api, else use the api on the same domain
const debug = process.env.NODE_ENV !== 'production';
const apiUrl = debug ? 'http://localhost:5001/api/' : `${window.location.protocol}//${window.location.host}/api/`;

function getApiUrl() {
  return apiUrl;
}

function createDefaultMetadata(metadataDefinition) {
  return {
    name: metadataDefinition.name,
    value: null,
    metadataDefinition,
  };
}
function combineMetadataWithMetadataDefinitions(metadata, metadataDefinitions) {
  return _.orderBy(
    _.concat(
      _.differenceWith(metadataDefinitions, metadata, (x, y) => x.name === y.name)
        .map(x => createDefaultMetadata(x)),
        metadata),
      ['name'], ['asc']);
}

export default {
  getApiUrl,
  combineMetadataWithMetadataDefinitions,
};
